import React, { useEffect, useState } from 'react'
import Logo from './Logo'
import NoMediaImage from './no_media.png'
import { IconButton } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import MenuIcon from '@material-ui/icons/Menu'
import clsx from 'clsx'
import Magnify from './magnify.png'

const useStyles = makeStyles(theme => {
    return {
        root: {
            background: 'white',
            zIndex: 3,
            display: 'flex', 
            position: 'fixed', 
            width: '100%',
            height: 100
        },
        menuButton: {
            margin: theme.spacing(2),
            color: theme.palette.primary.main
        },
        hide: {
            display: 'none',
        },
        searchRoot: {
            margin: '25px 20px',
            position: 'relative'
        },
        searchInput: {
            width: '100%',
            paddingLeft: 39,
            background: `url(${Magnify})9px center/25px no-repeat #fff`,
            height: '100%',
            border: '1px solid #ccc',
            fontSize: 15,
            color: '#666',
            boxSizing: 'border-box',
            fontWeight: 300,
            fontFamily: '\'Roboto\', Helvetica, Arial, Tahoma, Sans-Serif'
        },
        inputFocused: {
            width: '100%'
        },
        shareButton: {
            display: 'flex',
            alignItems: 'center',
            textAlign: 'center',
            textRendering: 'optimizeLegibility',
            background: 'transparent',
            fontFamily: 'futura-pt',
            fontWeight: 400,
            fontStyle: 'normal',
            fontSize: 16,
            letterSpacing: 2,
            textTransform: 'uppercase',
            textDecoration: 'none',
            padding: '1em 1.75em',
            backgroundColor: theme.palette.primary.main,
            webkitFontSmoothing: 'antialiased',
            lineHeight: '1em',
            margin: '20px 0',
            marginRight: 16,
            color: '#fff',
            border: 'none',
            transition: 'background-color .1s 0s ease-in-out,color .1s 0s ease-in-out',
            borderRadius: 300
        }
    }
})

export default function Header(props){

    const { app, searchValue, change, toggleDrawer, logoClick, keyDown } = props

    const classes = useStyles()

    const [logo, setLogo] = useState(NoMediaImage)

    const [inputFocused, setInputFocused] = useState(false)


    useEffect(() => {
        if(app){
            setLogo(app.image)
        }
    }, [app])

    const handleInputFocus = () => {
        setInputFocused(true)
    }

    const handleInputBlur = () => {
        setInputFocused(false)
    }


    return (
        <div data-testid="header" className={classes.root}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={toggleDrawer}
                  edge="start"
                  className={clsx(classes.menuButton)}>
                    <MenuIcon />
                 </IconButton>
                <div style={{padding: '0 2%'}}>
                    <Logo logo={logo} click={logoClick}/>
                </div>
                <div className={classes.searchRoot} style={{ width: app.userGeneratedContentAllowed ? 230 : '80%'}}>
                    <input 
                        onFocus={handleInputFocus} 
                        onBlur={handleInputBlur}
                        onKeyDown={keyDown}
                        onChange={change}
                        type="text" 
                        placeholder={'Search'}
                        value={searchValue} 
                        className={clsx(classes.searchInput, inputFocused && classes.inputFocused)} />
                </div> 
                {app.userGeneratedContentAllowed && (
                    <>
                    <div style={{ flexGrow: 1 }}/>
                    <a className={classes.shareButton} 
                        target={'__blank'}
                        href={`/present/${app._id}/ugc`}>
                            <strong>Share your story</strong>
                    </a>
                    </>
                )}
                
        </div>
    )
}